import { connect } from 'react-redux'
import { logout, getUser } from '../../store/user'
import PageLayoutView from './PageLayout'

const mapDispatchToProps = {
  logout,
  getUser,
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, mapDispatchToProps)(PageLayoutView)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayoutContainer.js